import React from "react";
import { FaMoneyBillWave, FaCreditCard, FaGlobe } from "react-icons/fa";

const paymentOptions = [
  {
    value: "cash",
    label: "Cash at Kios",
    sub: "Pay with cash at pickup",
    icon: <FaMoneyBillWave className="text-xl " />,
  },
  {
    value: "card",
    label: "Card at Kios",
    sub: "Pay with card at pickup counter",
    icon: <FaCreditCard className="text-xl " />,
  },
  {
    value: "online",
    label: "Online Payment",
    sub: "Pay securely online by Stripe",
    icon: <FaGlobe className="text-xl " />,
  },
];

const PaymentMethodSelector = ({ selected, onChange }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-text">Choose Payment Method</h2>
      <div>
        {paymentOptions.map((option, idx) => (
          <div
            key={option.value}
            onClick={() => onChange?.(option.value)}
            className={`cursor-pointer border rounded-xl px-4 py-3 flex items-start space-x-4 transition mb-4 last:mb-0
        ${
          selected === option.value
            ? "border-redlight bg-redlight"
            : "border-border hover:border-textGray"
        }`}
          >
            <div className="pt-1">{option.icon}</div>
            <div>
              <p className="font-semibold text-text">{option.label}</p>
              <p className="text-textGray text-sm">{option.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
